<script lang="ts" setup>
const props = defineProps<{
  tight?: boolean
}>()

const { t } = useI18n()
const { country } = useAuth()

const { data: storyBlokConfig } = useQueryStoryblok.getAppConfig({
  country,
  params: {
    resolve_relations: ['subscribe_modal_logo_cloud'],
  },
})

const logos = computed(() => {
  const logos = (storyBlokConfig.value?.story.content.subscribe_modal_logo_cloud || [])
  return logos.filter(logo => typeof logo !== 'string' && !!logo.content?.logo_black?.filename)
    .splice(0, props.tight ? 8 : 12) as Exclude<typeof logos, string[]>
})

const colClasses = computed(() => props.tight
  ? 'grid-cols-2 sm:grid-cols-4 gap-y-4'
  : 'grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-x-5 gap-y-10',
)
</script>

<template>
  <div
    v-if="logos.length"
    :class="tight ? 'space-y-4' : 'space-y-10'"
  >
    <p
      class="font-semibold"
      :class="tight ? 'text-base text-left' : 'text-center text-2xl'"
    >
      {{ t('subscribe.plans.refs.title') }}
    </p>

    <div
      class="
          grid
          place-items-center
          "
      :class="colClasses"
    >
      <img
        v-for="logo in logos"
        :key="logo.uuid"
        :src="logo.content?.logo_black?.filename"
        :class="tight ? 'h-6 w-24' : 'h-[33px] w-[132px]'"
      >
    </div>
  </div>
</template>
